import { Component, Input, OnDestroy } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { ShootProofDataProvider } from '@services/integrations/shootProof/shootProof.data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
	selector: 'integrate-shoot-proof-modal',
	template: require('./integrate-shoot-proof-modal.html')
})
export class IntegrateShootProofModal implements OnDestroy {
	@Input() shootProofCode: string;
	@Input() introductionText: string;

	button_disabled: boolean;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private messageService: MessageService,
		private activeModal: NgbActiveModal,
		private shootProofDataService: ShootProofDataProvider
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	saveShootProofSettings(): void {
		this.button_disabled = true;
		this.shootProofCode
			? this.setShootProofSettings()
			: this.updateShootProofSettings();
	}

	changePathAfterIntegration(): void {
		this.introductionText = '';
		this.button_disabled = false;
		if (this.shootProofCode) {
			window.history.replaceState(
				null,
				null,
				window.location.pathname.replace('/shootproof', '')
			);
		}
	}

	setShootProofSettings(): void {
		const settings = {
			code: this.shootProofCode,
			clientPortalText: this.introductionText || ''
		};
		this.shootProofDataService
			.setShootProofSettingsV1(settings)
			.pipe(
				finalize(() => this.changePathAfterIntegration()),
				takeUntil(this.unsubscribe)
			)
			.subscribe(
				() => {
					this.activeModal.close();
					this.messageService.showToaster('s_9', 'shootProof');
				},
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	updateShootProofSettings(): void {
		const settings = {
			clientPortalText: this.introductionText || ''
		};

		this.shootProofDataService
			.updateShootProofSettingsV1(settings)
			.pipe(
				finalize(() => (this.button_disabled = false)),
				takeUntil(this.unsubscribe)
			)
			.subscribe(
				() => {
					this.activeModal.close();
					this.messageService.showToaster('s_8', 'shootProof');
				},
				error => {
					const { errorMessage, errorTitle } = error.error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				}
			);
	}
	onDismiss(): void {
		this.activeModal.close();
		this.changePathAfterIntegration();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/integrations-section/modals/integrate-shoot-proof-modal/integrate-shoot-proof-modal.ts